// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CommsThreadTextarea from './logic'

export default function CommsThreadTextareaFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CommsThreadTextarea">
      <CommsThreadTextarea {...props}>
        {children}
      </CommsThreadTextarea>
    </Flow>
  )
}
